import { toast } from 'react-toastify';
import request from '../../../logic/utils/request';

const DeleteItem = async ({
  preloader, url, showError, fetchData, setShowWarn, setId,
}) => {
  preloader();
  await request(url, 'delete')
    .then(() => {
      fetchData();
      setId(false);
      toast.success('Выполнено');
    })
    .catch((e) => {
      if (+e.data.error.code === 15) {
        // Переводим технический комментарий на понятный пользователю язык
        if (e.data.error.comment) {
          const errorComment = e.data.error.comment;
          let translatedError = '';

          // Определяем тип ошибки по комментарию и переводим на русский
          if (errorComment.includes('queue is connected to some operator')) {
            translatedError = 'Очередь подключена к оператору и не может быть удалена';
          } else if (errorComment.includes('queue is connected')) {
            translatedError = 'Очередь используется в системе и не может быть удалена';
          } else if (errorComment.includes('is connected')) {
            translatedError = 'Объект связан с другими элементами системы и не может быть удален';
          } else {
            // Если нет специального перевода, используем текст из ответа или комментарий
            translatedError = (e.data.error.text && e.data.error.text.rus)
              ? e.data.error.text.rus
              : `${errorComment} (Объект используется и не может быть удален)`;
          }
          toast.error(translatedError);
        } else if (e.data.error.text && e.data.error.text.rus) {
          // Если есть русский текст ошибки, используем его
          toast.error(e.data.error.text.rus);
        } else {
          // Запасной вариант, если нет ни комментария, ни русского текста
          toast.error('Объект используется и не может быть удален');
        }
      } else {
        showError(e.data.error);
      }
    })
    .finally(() => {
      setShowWarn();
      preloader();
    });
};

export default DeleteItem;
